import { IconType } from 'react-icons'
import {
  TbRocket,
  TbUnlink,
  TbSettingsCheck,
  TbCloudDown,
  TbStars,
} from 'react-icons/tb'

export type SelfHostingFeaturesDataType = {
  Icon: IconType
  title: string
  description: string
}

export const selfHostingFeaturesData: SelfHostingFeaturesDataType[] = [
  {
    Icon: TbRocket,
    title: 'Run Integration App on your terms',
    description:
      'We provide docker containers and deployment charts. You run platform anywhere in any configurations. with no limits on instances, locations, or anything else you can think of.',
  },
  {
    Icon: TbUnlink,
    title: 'Minimal dependencies',
    description:
      'You can run it on any cloud or on-premise. The service only requires a Mongo-compatible database, basic S3-compatible storage, and Redis.',
  },
  {
    Icon: TbSettingsCheck,
    title:
      'Full control over rate limits, log retention, encryption, and security policies',
    description:
      'Configure any infrastructure parameters via environment variables. You can establish any limits or guarantees you need.',
  },
  {
    Icon: TbCloudDown,
    title: 'Seamlessly move between cloud and self-hosted environments',
    description:
      'Our API and CLI lets you migrate integrations and customer setups between cloud and self-hosted versions. Start in the cloud then move to self-hosted, move between multiple self-hosted instances, etc.',
  },
  {
    Icon: TbStars,
    title: 'Eliminate all the vendor-related risks',
    description:
      'Additional provisions in our contract let you keep running your integrations on your terms in any circumstances you can (or cannot) imagine. This lets you avoid any risks related to using a third party for your product integrations.',
  },
]
